import { Slide, useScrollTrigger } from '@mui/material';

export type HideOnScrollProps = {
  children: React.ReactElement;
  in?: boolean;
};

export const HideOnScroll = ({ in: customIn, children }: HideOnScrollProps) => {
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={customIn ?? !trigger}>
      {children}
    </Slide>
  );
};
